<template>
  <div>
    <div v-if="errored" class="errored">Une erreur s'est produite 😥</div>
    <div v-else-if="loaded" id="cv-classique" :class="'resume ' + person.lang">
      <div class="banner">
        <h1>{{ person.name.first }} {{ person.name.last }}</h1>
        <span class="meta">
          {{ person.position }}
          <span v-if="person.birth.year"> — {{ lang.born }} {{ person.birth.year }}</span>
        </span>
      </div>

      <section v-if="person.about" class="about">
        <h2>{{ lang.about }}</h2>
        <div class="description">{{ person.about }}</div>
      </section>

      <section v-if="person.experience.length" class="experience">
        <h2>{{ lang.experience }}</h2>
        <div v-for="experience in person.experience" class="item">
          <h3>
            {{ experience.position }}, {{ experience.company }} — {{ experience.timeperiod_from }} -
            {{ experience.timeperiod_to || lang.today }}
          </h3>
          <div v-if="experience.description" class="description">{{ experience.description }}</div>
        </div>
      </section>

      <section v-if="person.education.length" class="education">
        <h2>{{ lang.education }}</h2>
        <div v-for="education in person.education" class="item">
          <h3>
            {{ education.degree_role }}, {{ education.degree_structure }} —
            {{ education.timeperiod }}
          </h3>
          <div v-if="education.description" class="description">{{ education.description }}</div>
        </div>
      </section>

      <section v-if="person.projects.length" class="projects">
        <h2>{{ lang.projects }}</h2>
        <div v-for="project in person.projects" class="item">
          <h3>{{ project.name }}, {{ project.platform }}, {{ project.url }} — {{ project.timeperiod_from }} - {{ project.timeperiod_to }}</h3>
          <div v-if="project.description" class="description">{{ project.description }}</div>
        </div>
      </section>

      <section class="skills">
        <h2>{{ lang.skills }}</h2>
        <span v-for="skill in person.skills">{{ skill.name }}</span>
      </section>

      <section class="contact meta">
        <ul>
          <li v-if="person.contact.street">{{ person.contact.street }}, {{ person.contact.city }}</li>
          <li>
            <a :href="contactLinks.email">{{ person.contact.email }}</a>
          </li>
          <li>
            <a :href="'tel:' + person.contact.phone">{{ person.contact.phone }}</a>
          </li>
          <li v-if="person.contact.website">
            <a :href="person.contact.website" target="_blank"><i class="fa fa-globe"></i> {{ person.contact.website }}</a>
          </li>
          <li v-if="person.contact.github">
            <a :href="contactLinks.github" target="_blank"><i class="fa fa-github"></i> {{ person.contact.github }}</a>
          </li>
        </ul>
      </section>
    </div>
    <div v-else class="loading">Chargement en cours ⏰</div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getVueOptions } from './options';

const name = 'cv-classique';
export default Vue.component(name, getVueOptions(name));
</script>

<style lang="less" scoped>
@page cv-classique {
  margin: 2cm 0;
}

@page cv-classique:first {
  margin-top: 0;
}

@primary-color: #334155;
@secondary-color: #64748b;
@normal: 11pt;
@big: 20pt;
@small: 10pt;

#cv-classique {
  position: relative;
  color: @primary-color;
  font-family: 'Libre Baskerville', serif;
  font-weight: 400;
  font-size: @normal;
  line-height: 17pt;
  padding: 0 2cm;
  box-sizing: border-box;
  page: cv-classique;
  .ar& {
    direction: rtl;
    font-family: 'Noto Sans Arabic', 'Libre Baskerville', sans-serif;
  }

  .banner {
    margin-top: 2cm;
    text-align: center;

    h1 {
      font-size: @big;
      font-weight: 700;
      margin: 0;
    }
  }

  .meta {
    color: @secondary-color;
    font-size: @small;
  }

  section {
    margin: 2cm 0;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  h2 {
    font-size: @normal;
    font-weight: 700;
    text-transform: uppercase;
    margin: 0;
  }

  .description {
    white-space: pre-line;
  }

  .item:not(:last-child) {
    margin-bottom: 0.5cm;
  }

  h3 {
    font-size: @normal;
    font-weight: 700;
    margin: 0;
  }

  .skills span {
    &:after {
      content: ', ';
    }

    &:last-child:after {
      content: none;
    }
  }

  .contact ul {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      color: @secondary-color;
      text-decoration: none;
    }
  }
}
</style>
